module.exports = __webpack_public_path__ + "img/wutu.3b75b09f.png";